<div id="content-desktop">
  <header>
    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-10">
        </div>
        <div class="col-md-2">
          <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700; ">
            <a [routerLink]="['/home-espanol']" style="text-decoration: none; color: inherit; ">
              <div class="container" style="border: 1px solid #257dff; border-radius: 25px; ">
                &nbsp;&nbsp;Español
              </div>
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-12">
          <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700">
            GoogleAssistantPrivacyLitigation.com
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(877) 411-4704
          </span>
        </div>
      </div>
    </div>
    <br />
    <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #257dff ">
      <div class="container">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
          <ul class="navbar-nav flex-grow">
            <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
              <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Home</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/faq']" style="color: white; font-weight: bold">FAQs</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold ">Notice</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">File Your Claim</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/claim-form']" style="color:white; font-weight: bold ">Claim Form</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Court Documents</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/exclusion-request']" style="color:white; font-weight: bold ">File an Exclusion</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/contact']" style="color:white; font-weight: bold ">Contact Us</a>
            </li>
          </ul>
        </div>
      </div>

    </nav>

    <div class="text-center" style="font-weight:bold">
      <div class="container" style="border:1px solid #bebaba">

        <br />

        This official website is maintained by the Claims Administrator
        <br />
        <br />
      </div>
    </div>
  </header>
</div>

<div id="content-mobile">
  <header>
    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-10">
        </div>
        <div class="col-md-2">
          <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700; ">
            <a [routerLink]="['/home-espanol']" style="text-decoration: none; color: inherit; ">
              <div class="container" style="border: 1px solid #257dff; border-radius: 25px; ">
                &nbsp;&nbsp;Español
              </div>
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-12">
          <span style="padding-top: 3%; font-size: 1.2em; font-weight: 700; width: 100%; float: left">
            GoogleAssistantPrivacyLitigation.com
            (877) 411-4704
          </span>
        </div>
      </div>
    </div>
    <br />
    <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #257dff ">
      <div class="container">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
          <ul class="navbar-nav flex-grow">
            <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
              <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Home</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/faq']" style="color: white; font-weight: bold">FAQs</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold ">Notice</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">File Your Claim</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/claim-form']" style="color:white; font-weight: bold ">Claim Form</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Court Documents</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/exclusion-request']" style="color:white; font-weight: bold ">File an Exclusion</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/contact']" style="color:white; font-weight: bold ">Contact Us</a>
            </li>
          </ul>
        </div>
      </div>

    </nav>

    <div class="text-center" style="font-weight:bold">
      <div class="container" style="border:1px solid #bebaba">

        <br />

        This official website is maintained by the Claims Administrator
        <br />
        <br />
      </div>
    </div>
  </header>
</div>

<div class="row">
  <div class="col-md-12">

    <a [routerLink]="['/login']">
      <img src="../../../assets/main graphic 2.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 100%;">
    </a>

    <div class="panel-heading" style="background-color: #7dc7f4; color: black; text-align: center; font-weight: bold">
      <br />
      <h3>AM I INCLUDED IN THE SETTLEMENT?</h3>
      <br />
    </div>
    <div class="container" style="border:1px solid #bebaba">

      <br />
      <br />
      <b>You are a member of the Purchaser Settlement Class</b> if you are a User who purchased a Google-Made
      Device in the United States or its territories between May 18, 2016, and March 19, 2026.<br /><br />

      <b>You are a member of the Privacy Settlement Class</b> if you are a User of Google Assistant or were a
      member of a User’s Household between May 18, 2016, and March 19, 2026, and your communications
      were recorded or otherwise obtained by Google Assistant as a result of a False Accept or disclosed to
      any third-party review vendor.


      <br />
      <br />
    </div>

    <div class="panel-heading" style="background-color: #257dff; color: white; text-align: center; font-weight: bold">
      <br />
      <h3>
        SUBMIT A CLAIM FORM
      </h3>
      <br />
    </div>
  </div>
</div>
<div class="container" style="border:1px solid #bebaba">

  <br />


  <div class="row">
    <div class="col-md-6">

      <img src="../../../assets/file now.png" class="img-responsive" style="width:100%;  display: block; margin: 0 auto; width: 40%;">
    </div>
    <div class="col-md-6">
      <b>
        To receive a payment, you must complete and timely
        submit a valid Claim Form by August 27, 2026
      </b>. You may
      complete and submit an electronic Claim Form online <a [routerLink]="['/login']">here</a>
      or by mail to the address on the Claim Form postmarked
      by <b>August 27, 2026</b>. You can get a Claim Form by printing
      it   <a href="../../../assets/documents/In re Google Assistant Claim Form_Final.pdf"
              target="_blank">
        here
      </a> or by calling 1-877-411-4704.<br /><br />

    
    </div>
  </div>
  <div class="row">
    <br />
  </div>
</div>

<div class="panel-heading" style="background-color: #7dc7f4; color: black; text-align: center; font-weight: bold">
  <br />
  <h3>
    SUMMARY OF YOUR LEGAL RIGHTS AND OPTIONS
  </h3>
  <br />
</div>
<div class="container" style="border:1px solid #bebaba">

  <div class="row">
    <div class="col-md-12" style="text-align:center">
      <i>Your legal rights are affected even if you do not act. Read this notice carefully.</i>
    </div>
  </div>
  <div id="content-mobile">
    <div class="row" style="margin-left: 5%; margin-right: 5%; margin-top: 5%; width: 100%; float: left; ">
      <div class="col-md-12">
        <div class="table-responsive" style="overflow-x: auto;">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Option
                </th>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Explanation
                </th>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Deadline
                </th>
              </tr>

            </thead>
            <tbody>
              <tr>
                <td style="background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20% ">
                  Stay in the Settlement Class(es), Submit a Claim Form, and Receive a Payment
                </td>
                <td style="background-color:white; color:#3e4144; width:60%">
                  You must submit a valid Claim Form to receive a payment. This is the only way to get a payment. You will give up your rights to sue Google on your own for the claims in the lawsuit.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  The August 27, 2026, deadline has passed.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Rejoin the Settlement Classes (only for individuals who opted out of the litigation by the September 9, 2024 deadline)
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  If you previously opted out from this litigation by the deadline of September 9, 2024, based on the notice of the certified Purchaser Class, you remain opted out of this Settlement unless you take steps to opt back in, such as by filing a Claim Form.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  The August 27, 2026, deadline has passed.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Exclude Yourself
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  Get no payment.<br /><br />

                  This is the only option that allows you to keep your right to be part of any other lawsuit against Google about the claims
                  in this lawsuit.<br /><br />

                  If you previously opted out from this litigation by the deadline of September 9, 2024, based on the notice of the certified
                  Purchaser Class, you remain opted out of this Settlement and do not need to opt out again.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  The August 27, 2026, deadline has passed.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Object to the Settlement
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  You can write to the Court about why you like or do not like the Settlement.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  The August 27, 2026, deadline has passed.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Attend a Hearing
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  You can speak in Court about the fairness of the Settlement at the final approval hearing on October 1, 2026, if you provide timely notice of your intent to appear.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  The August 27, 2026, deadline has passed.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Do Nothing
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  Get no payment.  Give up your rights to sue Google about the claims in this lawsuit.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div id="content-desktop">
    <div class="row" style="margin-left:5%;margin-right:5%; margin-top:5%">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Option
                </th>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Explanation
                </th>
                <th colspan="1" style="background-color:#ffffff; color:#000000; font-weight:bold; font-size:1.2em; text-align:center;">
                  Deadline
                </th>
              </tr>

            </thead>
            <tbody>
              <tr>
                <td style="background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20% ">
                  Stay in the Settlement Class(es), Submit a Claim Form, and Receive a Payment
                </td>
                <td style="background-color:white; color:#3e4144; width:60%">
                  You must submit a valid Claim Form to receive a payment. This is the only way to get a payment. You will give up your rights to sue Google on your own for the claims in the lawsuit.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  The August 27, 2026, deadline has passed.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Rejoin the Settlement Classes (only for individuals who opted out of the litigation by the September 9, 2024 deadline)
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  If you previously opted out from this litigation by the deadline of September 9, 2024, based on the notice of the certified Purchaser Class, you remain opted out of this Settlement unless you take steps to opt back in, such as by filing a Claim Form.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  The August 27, 2026, deadline has passed.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Exclude Yourself
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  Get no payment.<br /><br />

                  This is the only option that allows you to keep your right to be part of any other lawsuit against Google about the claims
                  in this lawsuit.<br /><br />

                  If you previously opted out from this litigation by the deadline of September 9, 2024, based on the notice of the certified
                  Purchaser Class, you remain opted out of this Settlement and do not need to opt out again.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  The August 27, 2026, deadline has passed.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Object to the Settlement
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  You can write to the Court about why you like or do not like the Settlement.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  The August 27, 2026, deadline has passed.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Attend a Hearing
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  You can speak in Court about the fairness of the Settlement at the final approval hearing on October 1, 2026, if you provide timely notice of your intent to appear.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                  The August 27, 2026, deadline has passed.
                </td>
              </tr>
              <tr>
                <td style=" background-color: #D3D3D3; text-align: center; font-weight: bold; color: #000000; vertical-align: middle; width: 20%">
                  Do Nothing
                </td>
                <td style="background-color:white; color:#3e4144; width:40%">
                  Get no payment.  Give up your rights to sue Google about the claims in this lawsuit.
                </td>
                <td style="background-color: white; color: #3e4144; font-weight: bold; width: 20%">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />

  <div class="row">
    <div class="col-md-12">
      <img src="../../../assets/people graphic.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 50%;">
    </div>
  </div>
</div>
<div class="panel-heading" style="background-color: #257dff; color: black; text-align: center; font-weight: bold">
  <br />
  <div>
  </div>
  <p style="text-align:center; color:white">

    If you have questions or want more information,<br />
    you may call or you may contact the Claims Administrator by email, or by writing to:<br />
    Google Assistant Privacy Settlement<br />
    c/o A.B. Data, Ltd.<br />
    PO Box 170500<br />
    Milwaukee, WI 53217<br />
    Toll Free: 1-877-411-4704<br />
    Email: <a href="mailto:info@GoogleAssistantPrivacyLitigation.com" style="color:white">info@GoogleAssistantPrivacyLitigation.com</a><br /><br />

    <b>
      PLEASE DO NOT CALL OR WRITE TO THE COURT OR THE CLERK’S OFFICE FOR INFORMATION.<br />
      THE COURT CANNOT ANSWER ANY QUESTIONS.
    </b>
  </p>
  <br />
</div>
<br />
<br />

























